import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    formControl: {
		//margin: theme.spacing(2),
	},

	paper: {
		backgroundColor: theme.palette.background.paper,
		//border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 2, 2),
		width: "30%",
		"&:focus": {
			outline: "none"
		}
	},

	modal: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "center",
		//position: "absolute",
		overflow: "scroll",
		//height: "100%",
	},
	header: {
		padding: "12px 0",
		borderBottom: "1px solid darkgrey",
		color: "white",
	},
	content: {
		padding: 12,
		textAlign: "center",
	},
	footer: {
		borderTop: "1px solid darkgrey",
		padding: 12,
		textAlign: "center",
	},
	buttonStyle: {
		margin: "12px",
		width: "120px",
		height: "60px",
		color: "black",
		background: "white",
		textAlign: "center",
		"&:hover": {
			backgroundColor: "#75380c",
			color: "black",
		},
	},
	selectedButtonStyle: {
		margin: "12px",
		width: "120px",
		height: "60px",
		color: "black",
		background: "#75380c",
		textAlign: "center",
		backgroundColor: "#DE7824",
	},
	buttonAction: {
		margin: "12px",
		width: "100px",
		height: "40px",
	},
	gridStyle: {
		justifyContent: "space-evenly",
	},
	assetCategory: {
		backgroundColor: "#022f40",
		borderBottom: "1px inset #43628e",
	},
	assetType: {
		backgroundColor: "#4b4e6d",
	},
}));
